/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../workflow/ui_elements/common';
import '../glyph/glyph_icon';
import '../component/rich_text';
import '../../../deposits/bank_account_service';
import '../component/component';
import '../transfer_common/client_capable_flow';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "common": {
            "nested": {
              "bank_account": {
                "nested": {
                  "CreatePlaidLinkSessionStep": {
                    "fields": {
                      "identifier": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "viewLogEvent": {
                        "type": ".squareup.bbfrontend.service.v1.LogEvent",
                        "id": 2,
                        "rule": "optional"
                      },
                      "step": {
                        "type": ".squareup.bbfrontend.common.bank_account.CreatePlaidLinkSessionStep.PlaidLinkingStep",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "PlaidLinkingStep": {
                        "fields": {
                          "plaidConsent": {
                            "type": ".squareup.bbfrontend.common.bank_account.CreatePlaidLinkSessionStep.PlaidLinkingStep.PlaidConsent",
                            "id": 1
                          },
                          "plaidResultStep": {
                            "type": ".squareup.bbfrontend.common.bank_account.PlaidResultStep",
                            "id": 3
                          },
                          "accountOwnerRole": {
                            "type": ".squareup.bbfrontend.common.bank_account.CreatePlaidLinkSessionStep.PlaidLinkingStep.AccountOwnerRole",
                            "id": 4
                          }
                        },
                        "nested": {
                          "FeatureRow": {
                            "fields": {
                              "icon": {
                                "type": ".squareup.bbfrontend.common.glyph.GlyphIcon",
                                "id": 1,
                                "rule": "optional"
                              },
                              "description": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "style": {
                                "type": ".squareup.bbfrontend.common.bank_account.CreatePlaidLinkSessionStep.PlaidLinkingStep.FeatureRow.Style",
                                "id": 3,
                                "rule": "optional",
                                "options": {
                                  "default": "BOLD"
                                }
                              },
                              "title": {
                                "type": "string",
                                "id": 4,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "Style": {
                                "values": {
                                  "REGULAR": 0,
                                  "BOLD": 1
                                }
                              }
                            }
                          },
                          "PlaidConsent": {
                            "fields": {
                              "title": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "description": {
                                "type": ".squareup.bbfrontend.common.component.RichText",
                                "id": 2,
                                "rule": "optional"
                              },
                              "featureRows": {
                                "type": ".squareup.bbfrontend.common.bank_account.CreatePlaidLinkSessionStep.PlaidLinkingStep.FeatureRow",
                                "id": 3,
                                "rule": "repeated"
                              },
                              "consentCopy": {
                                "type": ".squareup.bbfrontend.common.component.RichText",
                                "id": 4,
                                "rule": "optional"
                              },
                              "buttons": {
                                "type": ".squareup.bbfrontend.common.bank_account.Button",
                                "id": 5,
                                "rule": "repeated"
                              },
                              "copyToken": {
                                "type": "string",
                                "id": 6,
                                "rule": "optional"
                              }
                            }
                          },
                          "PlaidResult": {
                            "fields": {
                              "icon": {
                                "type": ".squareup.bbfrontend.common.glyph.GlyphIcon",
                                "id": 1,
                                "rule": "optional"
                              },
                              "iconStyle": {
                                "type": ".squareup.bbfrontend.common.bank_account.CreatePlaidLinkSessionStep.PlaidLinkingStep.PlaidResult.IconStyle",
                                "id": 2,
                                "rule": "optional"
                              },
                              "title": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              },
                              "description": {
                                "type": "string",
                                "id": 4,
                                "rule": "optional"
                              },
                              "buttons": {
                                "type": ".squareup.bbfrontend.common.bank_account.Button",
                                "id": 5,
                                "rule": "repeated"
                              }
                            },
                            "nested": {
                              "IconStyle": {
                                "values": {
                                  "UNKNOWN": 0,
                                  "EMPHASIS": 1,
                                  "CRITICAL": 2,
                                  "WARNING": 3,
                                  "SUCCESS": 4
                                }
                              }
                            }
                          },
                          "SelectionRow": {
                            "fields": {
                              "description": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "value": {
                                "type": ".squareup.deposits.bank_account_service.AccountHolderRelationshipToBusiness",
                                "id": 2,
                                "rule": "optional"
                              },
                              "style": {
                                "type": ".squareup.bbfrontend.common.bank_account.CreatePlaidLinkSessionStep.PlaidLinkingStep.SelectionRow.Style",
                                "id": 3,
                                "rule": "optional",
                                "options": {
                                  "default": "BOLD"
                                }
                              }
                            },
                            "nested": {
                              "Style": {
                                "values": {
                                  "REGULAR": 0,
                                  "BOLD": 1
                                }
                              }
                            }
                          },
                          "AccountOwnerRole": {
                            "fields": {
                              "title": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "selectionRows": {
                                "type": ".squareup.bbfrontend.common.bank_account.CreatePlaidLinkSessionStep.PlaidLinkingStep.SelectionRow",
                                "id": 2,
                                "rule": "repeated"
                              },
                              "buttons": {
                                "type": ".squareup.bbfrontend.common.bank_account.Button",
                                "id": 3,
                                "rule": "repeated"
                              },
                              "description": {
                                "type": "string",
                                "id": 4,
                                "rule": "optional"
                              }
                            }
                          },
                          "step": {
                            "oneof": ["plaidConsent", "plaidResultStep", "accountOwnerRole"]
                          }
                        }
                      }
                    }
                  },
                  "CreateAndLinkBankAccountFromPlaidLinkSessionStep": {
                    "fields": {
                      "identifier": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "viewLogEvent": {
                        "type": ".squareup.bbfrontend.service.v1.LogEvent",
                        "id": 2,
                        "rule": "optional"
                      },
                      "step": {
                        "type": ".squareup.bbfrontend.common.bank_account.CreateAndLinkBankAccountFromPlaidLinkSessionStep.CreateAndLinkBankAccountFromPlaidLinkStep",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "CreateAndLinkBankAccountFromPlaidLinkStep": {
                        "fields": {
                          "plaidResultStep": {
                            "type": ".squareup.bbfrontend.common.bank_account.PlaidResultStep",
                            "id": 1
                          },
                          "plaidDirectDebitMandateStep": {
                            "type": ".squareup.bbfrontend.common.bank_account.PlaidDirectDebitMandateStep",
                            "id": 2
                          },
                          "multipleBankAccountsStep": {
                            "type": ".squareup.bbfrontend.common.bank_account.MultipleBankAccountsStep",
                            "id": 3
                          }
                        },
                        "nested": {
                          "step": {
                            "oneof": ["plaidResultStep", "plaidDirectDebitMandateStep", "multipleBankAccountsStep"]
                          }
                        }
                      }
                    }
                  },
                  "PlaidResultStep": {
                    "fields": {
                      "icon": {
                        "type": ".squareup.bbfrontend.common.glyph.GlyphIcon",
                        "id": 1,
                        "rule": "optional"
                      },
                      "iconStyle": {
                        "type": ".squareup.bbfrontend.common.bank_account.PlaidResultStep.IconStyle",
                        "id": 2,
                        "rule": "optional"
                      },
                      "title": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "description": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "buttons": {
                        "type": ".squareup.bbfrontend.common.bank_account.Button",
                        "id": 5,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "IconStyle": {
                        "values": {
                          "UNKNOWN": 0,
                          "EMPHASIS": 1,
                          "CRITICAL": 2,
                          "WARNING": 3,
                          "SUCCESS": 4
                        }
                      }
                    }
                  },
                  "MultipleBankAccountsStep": {
                    "fields": {
                      "title": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "description": {
                        "type": ".squareup.bbfrontend.common.component.RichText",
                        "id": 2,
                        "rule": "optional"
                      },
                      "bankAccountRows": {
                        "type": ".squareup.bbfrontend.common.bank_account.MultipleBankAccountsStep.BankAccountRow",
                        "id": 3,
                        "rule": "repeated"
                      },
                      "buttons": {
                        "type": ".squareup.bbfrontend.common.bank_account.Button",
                        "id": 4,
                        "rule": "repeated"
                      },
                      "alertBanner": {
                        "type": ".squareup.bbfrontend.common.bank_account.MultipleBankAccountsStep.AlertBanner",
                        "id": 5,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "BankAccountRow": {
                        "fields": {
                          "label": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "value": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "isSelected": {
                            "type": "bool",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "AlertBanner": {
                        "fields": {
                          "description": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "iconStyle": {
                            "type": ".squareup.bbfrontend.common.bank_account.MultipleBankAccountsStep.AlertBanner.IconStyle",
                            "id": 2,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "IconStyle": {
                            "values": {
                              "UNKNOWN": 0,
                              "EMPHASIS": 1,
                              "CRITICAL": 2,
                              "WARNING": 3
                            }
                          }
                        }
                      }
                    }
                  },
                  "PlaidDirectDebitMandateStep": {
                    "fields": {
                      "title": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "description": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "consent": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "directDebitGuarantee": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "directDebitLogo": {
                        "type": ".squareup.bbfrontend.common.glyph.GlyphIcon",
                        "id": 5,
                        "rule": "optional"
                      },
                      "directDebitUrl": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      },
                      "directDebitSections": {
                        "type": ".squareup.bbfrontend.common.bank_account.PlaidDirectDebitMandateStep.DirectDebitMandateSection",
                        "id": 7,
                        "rule": "repeated"
                      },
                      "buttons": {
                        "type": ".squareup.bbfrontend.common.bank_account.Button",
                        "id": 8,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "DirectDebitSectionName": {
                        "values": {
                          "DO_NOT_USE_SECTION": 0,
                          "PERSONAL_INFO": 1,
                          "BANK_INFO": 2,
                          "SQUARE_INFO": 3
                        }
                      },
                      "DirectDebitMandateRow": {
                        "fields": {
                          "label": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "description": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "richtextDescription": {
                            "type": ".squareup.bbfrontend.common.component.RichText",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "DirectDebitMandateSection": {
                        "fields": {
                          "sectionName": {
                            "type": ".squareup.bbfrontend.common.bank_account.PlaidDirectDebitMandateStep.DirectDebitSectionName",
                            "id": 1,
                            "rule": "optional"
                          },
                          "title": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "directDebitMandateRows": {
                            "type": ".squareup.bbfrontend.common.bank_account.PlaidDirectDebitMandateStep.DirectDebitMandateRow",
                            "id": 3,
                            "rule": "repeated"
                          }
                        }
                      }
                    }
                  },
                  "Button": {
                    "fields": {
                      "identifier": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "buttonDescription": {
                        "type": ".squareup.bbfrontend.common.component.ButtonDescription",
                        "id": 2,
                        "rule": "optional"
                      },
                      "plaidLinkSessionAction": {
                        "type": ".squareup.bbfrontend.common.bank_account.PlaidLinkSessionAction",
                        "id": 3
                      }
                    },
                    "nested": {
                      "action": {
                        "oneof": ["plaidLinkSessionAction"]
                      }
                    }
                  },
                  "PlaidLinkSessionAction": {
                    "fields": {
                      "clickLogEvent": {
                        "type": ".squareup.bbfrontend.service.v1.LogEvent",
                        "id": 1,
                        "rule": "optional"
                      },
                      "navigation": {
                        "type": ".squareup.bbfrontend.common.bank_account.PlaidLinkSessionAction.Navigation",
                        "id": 2
                      },
                      "clientFlow": {
                        "type": ".squareup.bbfrontend.common.transfer_common.TransferClientCapableFlow",
                        "id": 3
                      }
                    },
                    "nested": {
                      "Navigation": {
                        "values": {
                          "DO_NOT_USE_NAVIGATION": 0,
                          "NEXT": 1,
                          "FINISH": 2
                        }
                      },
                      "action": {
                        "oneof": ["navigation", "clientFlow"]
                      }
                    }
                  },
                  "PlaidLinkSession": {
                    "fields": {
                      "sessionToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "linkToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.CreatePlaidLinkSessionStep && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.CreatePlaidLinkSessionStep?.nested?.PlaidLinkingStep && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.CreatePlaidLinkSessionStep?.nested?.PlaidLinkingStep?.nested?.FeatureRow && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.CreatePlaidLinkSessionStep?.nested?.PlaidLinkingStep?.nested?.FeatureRow?.nested?.Style && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.CreatePlaidLinkSessionStep?.nested?.PlaidLinkingStep?.nested?.PlaidConsent && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.CreatePlaidLinkSessionStep?.nested?.PlaidLinkingStep?.nested?.PlaidResult && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.CreatePlaidLinkSessionStep?.nested?.PlaidLinkingStep?.nested?.PlaidResult?.nested?.IconStyle && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.CreatePlaidLinkSessionStep?.nested?.PlaidLinkingStep?.nested?.SelectionRow && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.CreatePlaidLinkSessionStep?.nested?.PlaidLinkingStep?.nested?.SelectionRow?.nested?.Style && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.CreatePlaidLinkSessionStep?.nested?.PlaidLinkingStep?.nested?.AccountOwnerRole && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.CreateAndLinkBankAccountFromPlaidLinkSessionStep && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.CreateAndLinkBankAccountFromPlaidLinkSessionStep?.nested?.CreateAndLinkBankAccountFromPlaidLinkStep && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.PlaidResultStep && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.PlaidResultStep?.nested?.IconStyle && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.MultipleBankAccountsStep && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.MultipleBankAccountsStep?.nested?.BankAccountRow && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.MultipleBankAccountsStep?.nested?.AlertBanner && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.MultipleBankAccountsStep?.nested?.AlertBanner?.nested?.IconStyle && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.PlaidDirectDebitMandateStep && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.PlaidDirectDebitMandateStep?.nested?.DirectDebitSectionName && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.PlaidDirectDebitMandateStep?.nested?.DirectDebitMandateRow && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.PlaidDirectDebitMandateStep?.nested?.DirectDebitMandateSection && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.Button && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.PlaidLinkSessionAction && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.PlaidLinkSessionAction?.nested?.Navigation && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.PlaidLinkSession) {
  $root.addJSON(jsonData);
}

/**
 * Create Plaid Link Session Step
 *
 * SOURCE CreatePlaidLinkSessionStep @ squareup/bbfrontend/common/bank_account/plaid_linking_models.proto at 20:1
 */
export const CreatePlaidLinkSessionStep = $root.lookupType('squareup.bbfrontend.common.bank_account.CreatePlaidLinkSessionStep');
fixType(CreatePlaidLinkSessionStep, {
  identifier: {
    notEmpty: true
  },
  step: {
    required: true
  }
});
Builder.createAndAttachToType(CreatePlaidLinkSessionStep);
/**
 * SOURCE PlaidLinkingStep @ squareup/bbfrontend/common/bank_account/plaid_linking_models.proto at 30:3
 */
CreatePlaidLinkSessionStep.PlaidLinkingStep = $root.lookupType('squareup.bbfrontend.common.bank_account.CreatePlaidLinkSessionStep.PlaidLinkingStep');
fixType(CreatePlaidLinkSessionStep.PlaidLinkingStep);
Builder.createAndAttachToType(CreatePlaidLinkSessionStep.PlaidLinkingStep);
/**
 * SOURCE FeatureRow @ squareup/bbfrontend/common/bank_account/plaid_linking_models.proto at 43:5
 */
CreatePlaidLinkSessionStep.PlaidLinkingStep.FeatureRow = $root.lookupType('squareup.bbfrontend.common.bank_account.CreatePlaidLinkSessionStep.PlaidLinkingStep.FeatureRow');
fixType(CreatePlaidLinkSessionStep.PlaidLinkingStep.FeatureRow, {
  icon: {
    required: true
  },
  description: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreatePlaidLinkSessionStep.PlaidLinkingStep.FeatureRow);
/**
 * SOURCE Style @ squareup/bbfrontend/common/bank_account/plaid_linking_models.proto at 44:7
 */
CreatePlaidLinkSessionStep.PlaidLinkingStep.FeatureRow.Style = $root.lookupEnum('squareup.bbfrontend.common.bank_account.CreatePlaidLinkSessionStep.PlaidLinkingStep.FeatureRow.Style').values;
/**
 * SOURCE PlaidConsent @ squareup/bbfrontend/common/bank_account/plaid_linking_models.proto at 62:5
 */
CreatePlaidLinkSessionStep.PlaidLinkingStep.PlaidConsent = $root.lookupType('squareup.bbfrontend.common.bank_account.CreatePlaidLinkSessionStep.PlaidLinkingStep.PlaidConsent');
fixType(CreatePlaidLinkSessionStep.PlaidLinkingStep.PlaidConsent, {
  title: {
    notEmpty: true
  },
  description: {
    required: true
  },
  consentCopy: {
    required: true
  },
  copyToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreatePlaidLinkSessionStep.PlaidLinkingStep.PlaidConsent);
/**
 * SOURCE PlaidResult @ squareup/bbfrontend/common/bank_account/plaid_linking_models.proto at 82:5
 */
CreatePlaidLinkSessionStep.PlaidLinkingStep.PlaidResult = $root.lookupType('squareup.bbfrontend.common.bank_account.CreatePlaidLinkSessionStep.PlaidLinkingStep.PlaidResult');
fixType(CreatePlaidLinkSessionStep.PlaidLinkingStep.PlaidResult, {
  icon: {
    required: true
  },
  iconStyle: {
    required: true
  },
  title: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreatePlaidLinkSessionStep.PlaidLinkingStep.PlaidResult);
/**
 * SOURCE IconStyle @ squareup/bbfrontend/common/bank_account/plaid_linking_models.proto at 83:7
 */
CreatePlaidLinkSessionStep.PlaidLinkingStep.PlaidResult.IconStyle = $root.lookupEnum('squareup.bbfrontend.common.bank_account.CreatePlaidLinkSessionStep.PlaidLinkingStep.PlaidResult.IconStyle').values;
/**
 * SOURCE SelectionRow @ squareup/bbfrontend/common/bank_account/plaid_linking_models.proto at 107:5
 */
CreatePlaidLinkSessionStep.PlaidLinkingStep.SelectionRow = $root.lookupType('squareup.bbfrontend.common.bank_account.CreatePlaidLinkSessionStep.PlaidLinkingStep.SelectionRow');
fixType(CreatePlaidLinkSessionStep.PlaidLinkingStep.SelectionRow, {
  description: {
    notEmpty: true
  },
  value: {
    required: true
  }
});
Builder.createAndAttachToType(CreatePlaidLinkSessionStep.PlaidLinkingStep.SelectionRow);
/**
 * SOURCE Style @ squareup/bbfrontend/common/bank_account/plaid_linking_models.proto at 108:7
 */
CreatePlaidLinkSessionStep.PlaidLinkingStep.SelectionRow.Style = $root.lookupEnum('squareup.bbfrontend.common.bank_account.CreatePlaidLinkSessionStep.PlaidLinkingStep.SelectionRow.Style').values;
/**
 * SOURCE AccountOwnerRole @ squareup/bbfrontend/common/bank_account/plaid_linking_models.proto at 123:5
 */
CreatePlaidLinkSessionStep.PlaidLinkingStep.AccountOwnerRole = $root.lookupType('squareup.bbfrontend.common.bank_account.CreatePlaidLinkSessionStep.PlaidLinkingStep.AccountOwnerRole');
fixType(CreatePlaidLinkSessionStep.PlaidLinkingStep.AccountOwnerRole, {
  title: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreatePlaidLinkSessionStep.PlaidLinkingStep.AccountOwnerRole);
/**
 * Create and Link Bank Account From Plaid Link Session Step
 *
 * SOURCE CreateAndLinkBankAccountFromPlaidLinkSessionStep @ squareup/bbfrontend/common/bank_account/plaid_linking_models.proto at 140:1
 */
export const CreateAndLinkBankAccountFromPlaidLinkSessionStep = $root.lookupType('squareup.bbfrontend.common.bank_account.CreateAndLinkBankAccountFromPlaidLinkSessionStep');
fixType(CreateAndLinkBankAccountFromPlaidLinkSessionStep, {
  identifier: {
    notEmpty: true
  },
  step: {
    required: true
  }
});
Builder.createAndAttachToType(CreateAndLinkBankAccountFromPlaidLinkSessionStep);
/**
 * SOURCE CreateAndLinkBankAccountFromPlaidLinkStep @ squareup/bbfrontend/common/bank_account/plaid_linking_models.proto at 150:3
 */
CreateAndLinkBankAccountFromPlaidLinkSessionStep.CreateAndLinkBankAccountFromPlaidLinkStep = $root.lookupType('squareup.bbfrontend.common.bank_account.CreateAndLinkBankAccountFromPlaidLinkSessionStep.CreateAndLinkBankAccountFromPlaidLinkStep');
fixType(CreateAndLinkBankAccountFromPlaidLinkSessionStep.CreateAndLinkBankAccountFromPlaidLinkStep);
Builder.createAndAttachToType(CreateAndLinkBankAccountFromPlaidLinkSessionStep.CreateAndLinkBankAccountFromPlaidLinkStep);
/**
 * SOURCE PlaidResultStep @ squareup/bbfrontend/common/bank_account/plaid_linking_models.proto at 164:1
 */
export const PlaidResultStep = $root.lookupType('squareup.bbfrontend.common.bank_account.PlaidResultStep');
fixType(PlaidResultStep, {
  icon: {
    required: true
  },
  iconStyle: {
    required: true
  },
  title: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(PlaidResultStep);
/**
 * SOURCE IconStyle @ squareup/bbfrontend/common/bank_account/plaid_linking_models.proto at 165:3
 */
PlaidResultStep.IconStyle = $root.lookupEnum('squareup.bbfrontend.common.bank_account.PlaidResultStep.IconStyle').values;
/**
 * SOURCE MultipleBankAccountsStep @ squareup/bbfrontend/common/bank_account/plaid_linking_models.proto at 189:1
 */
export const MultipleBankAccountsStep = $root.lookupType('squareup.bbfrontend.common.bank_account.MultipleBankAccountsStep');
fixType(MultipleBankAccountsStep, {
  title: {
    notEmpty: true
  },
  description: {
    required: true
  }
});
Builder.createAndAttachToType(MultipleBankAccountsStep);
/**
 * SOURCE BankAccountRow @ squareup/bbfrontend/common/bank_account/plaid_linking_models.proto at 190:3
 */
MultipleBankAccountsStep.BankAccountRow = $root.lookupType('squareup.bbfrontend.common.bank_account.MultipleBankAccountsStep.BankAccountRow');
fixType(MultipleBankAccountsStep.BankAccountRow, {
  label: {
    notEmpty: true
  },
  value: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(MultipleBankAccountsStep.BankAccountRow);
/**
 * SOURCE AlertBanner @ squareup/bbfrontend/common/bank_account/plaid_linking_models.proto at 198:3
 */
MultipleBankAccountsStep.AlertBanner = $root.lookupType('squareup.bbfrontend.common.bank_account.MultipleBankAccountsStep.AlertBanner');
fixType(MultipleBankAccountsStep.AlertBanner, {
  description: {
    notEmpty: true
  },
  iconStyle: {
    required: true
  }
});
Builder.createAndAttachToType(MultipleBankAccountsStep.AlertBanner);
/**
 * SOURCE IconStyle @ squareup/bbfrontend/common/bank_account/plaid_linking_models.proto at 199:5
 */
MultipleBankAccountsStep.AlertBanner.IconStyle = $root.lookupEnum('squareup.bbfrontend.common.bank_account.MultipleBankAccountsStep.AlertBanner.IconStyle').values;
/**
 * SOURCE PlaidDirectDebitMandateStep @ squareup/bbfrontend/common/bank_account/plaid_linking_models.proto at 222:1
 */
export const PlaidDirectDebitMandateStep = $root.lookupType('squareup.bbfrontend.common.bank_account.PlaidDirectDebitMandateStep');
fixType(PlaidDirectDebitMandateStep, {
  title: {
    notEmpty: true
  },
  description: {
    notEmpty: true
  },
  consent: {
    notEmpty: true
  },
  directDebitGuarantee: {
    notEmpty: true
  },
  directDebitLogo: {
    required: true
  },
  directDebitUrl: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(PlaidDirectDebitMandateStep);
/**
 * SOURCE DirectDebitSectionName @ squareup/bbfrontend/common/bank_account/plaid_linking_models.proto at 223:3
 */
PlaidDirectDebitMandateStep.DirectDebitSectionName = $root.lookupEnum('squareup.bbfrontend.common.bank_account.PlaidDirectDebitMandateStep.DirectDebitSectionName').values;
/**
 * SOURCE DirectDebitMandateRow @ squareup/bbfrontend/common/bank_account/plaid_linking_models.proto at 230:3
 */
PlaidDirectDebitMandateStep.DirectDebitMandateRow = $root.lookupType('squareup.bbfrontend.common.bank_account.PlaidDirectDebitMandateStep.DirectDebitMandateRow');
fixType(PlaidDirectDebitMandateStep.DirectDebitMandateRow, {
  label: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(PlaidDirectDebitMandateStep.DirectDebitMandateRow);
/**
 * SOURCE DirectDebitMandateSection @ squareup/bbfrontend/common/bank_account/plaid_linking_models.proto at 239:3
 */
PlaidDirectDebitMandateStep.DirectDebitMandateSection = $root.lookupType('squareup.bbfrontend.common.bank_account.PlaidDirectDebitMandateStep.DirectDebitMandateSection');
fixType(PlaidDirectDebitMandateStep.DirectDebitMandateSection, {
  sectionName: {
    required: true
  }
});
Builder.createAndAttachToType(PlaidDirectDebitMandateStep.DirectDebitMandateSection);
/**
 * SOURCE Button @ squareup/bbfrontend/common/bank_account/plaid_linking_models.proto at 267:1
 */
export const Button = $root.lookupType('squareup.bbfrontend.common.bank_account.Button');
fixType(Button, {
  identifier: {
    notEmpty: true
  },
  buttonDescription: {
    required: true
  }
});
Builder.createAndAttachToType(Button);
/**
 * SOURCE PlaidLinkSessionAction @ squareup/bbfrontend/common/bank_account/plaid_linking_models.proto at 279:1
 */
export const PlaidLinkSessionAction = $root.lookupType('squareup.bbfrontend.common.bank_account.PlaidLinkSessionAction');
fixType(PlaidLinkSessionAction);
Builder.createAndAttachToType(PlaidLinkSessionAction);
/**
 * SOURCE Navigation @ squareup/bbfrontend/common/bank_account/plaid_linking_models.proto at 280:3
 */
PlaidLinkSessionAction.Navigation = $root.lookupEnum('squareup.bbfrontend.common.bank_account.PlaidLinkSessionAction.Navigation').values;
/**
 * SOURCE PlaidLinkSession @ squareup/bbfrontend/common/bank_account/plaid_linking_models.proto at 300:1
 */
export const PlaidLinkSession = $root.lookupType('squareup.bbfrontend.common.bank_account.PlaidLinkSession');
fixType(PlaidLinkSession, {
  sessionToken: {
    notEmpty: true
  },
  linkToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(PlaidLinkSession);